import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import {
  CustomerOrderDataService,
  EnquiryBasicData,
  InvoiceData,
  OrderItemData,
  QuotationData,
  RelationshipManagerData,
} from '@app/core/services/customer-order/customer-order-data.service';
import { CarouselComponent } from '@app/shared/components/carousel/carousel.component';
import { FileDownloadButtonComponent } from '@app/shared/components/file-download-button/file-download-button.component';
import { LoadingSpinnerComponent } from '@app/shared/components/loading-spinner/loading-spinner.component';
import { ReportIssueButtonComponent } from '@app/shared/components/report-issue-button/report-issue-button.component';
import { ShareRequirementsButtonComponent } from '@app/shared/components/share-requirements-button/share-requirements-button.component';
import { EntityType, ScreenType } from '@app/shared/enums/enums';
import { getInvoiceDeliveryStatusChipClass } from '@app/shared/functions/chips';
import { SelectionOption } from '@app/shared/interfaces/selection-option';
import { MobileNumberFormatPipe } from '@app/shared/pipes/mobile-number-format.pipe';
import { PincodeNumberFormatPipe } from '@app/shared/pipes/pincode-number-format.pipe';
import { environment } from '@env/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-general-desktop',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatChipsModule,
    LoadingSpinnerComponent,
    FileDownloadButtonComponent,
    ReportIssueButtonComponent,
    MobileNumberFormatPipe,
    PincodeNumberFormatPipe,
    ShareRequirementsButtonComponent,
    MatDialogModule,
    CarouselComponent,
  ],
  providers: [CustomerOrderDataService],
  templateUrl: './general-desktop.component.html',
  styleUrl: './general-desktop.component.scss',
})
export class GeneralDesktopComponent implements OnInit, OnDestroy {
  private routeSub!: Subscription;

  isInternalUser: boolean = false;

  customerOrderId!: string;
  entityType!: EntityType;
  publicRequirementsId!: string;

  orderData!: { [key: string]: any };

  orderDataStruct!: { [key: string]: any };

  isLoading!: boolean;

  screenType: ScreenType = ScreenType.DESKTOP;

  customerName!: string;
  enquiryBasicData!: EnquiryBasicData;

  orderItems!: OrderItemData[];
  orderItemDataSource!: MatTableDataSource<OrderItemData>;

  quotationList!: QuotationData[];
  invoiceList!: InvoiceData[];

  relationshipManagerData!: RelationshipManagerData;

  loginUrl: string = `${environment.API_URL}/login`;

  requirementItemColumns: string[] = [
    'category',
    'product',
    'make',
    'grade',
    'brand',
    'type',
    'property',
    'dimension',
    'customDimensions',

    'qty',
  ];

  constructor(
    private route: ActivatedRoute,
    private customerOrderDataService: CustomerOrderDataService
  ) {
    this.isLoading = true;

    this.entityType = EntityType.CUSTOMER_ORDER;
  }

  async ngOnInit() {
    this.routeSub = this.route.params.subscribe((params) => {
      console.info('desktop', params);

      this.customerOrderId = params['id'];
    });

    if (this.route.snapshot.queryParamMap.get('isInternalUser')) {
      this.isInternalUser = this.route.snapshot.queryParamMap.get('isInternalUser') === 'true';
      console.info(this.isInternalUser);
    }

    await this.customerOrderDataService.runService(this.customerOrderId, this.isInternalUser);
    this.isLoading = false;

    this.orderData = this.customerOrderDataService.getOrderData();

    this.orderDataStruct = this.customerOrderDataService.getOrderDataStructured();

    this.customerName = this.orderDataStruct['customerName'];

    this.enquiryBasicData = this.orderDataStruct['enquiryBasicData'];

    this.relationshipManagerData = this.orderDataStruct['relationshipManagerData'];

    this.orderItemDataSource = new MatTableDataSource(this.orderDataStruct['orderItemList']);

    this.quotationList = this.orderDataStruct['quotationList'];

    this.invoiceList = this.orderDataStruct['invoiceList'];

    this.publicRequirementsId = this.orderDataStruct['publicRequirementsId'];
  }

  ngOnDestroy(): void {
    return;
  }

  getInvoiceStatusChipClass(status: SelectionOption) {
    return getInvoiceDeliveryStatusChipClass(status);
  }
}
